__turbopack_context__.v({
  "className": "instrument_serif_fc59a73a-module__nCg2GW__className",
});
